import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polygon, { points: "12 2 19 21 12 17 5 21 12 2", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Navigation2";
const Navigation2 = memo(themed(Icon));
export {
  Navigation2
};
//# sourceMappingURL=navigation-2.js.map
